import React, { useState, useEffect } from "react";
import { app } from "../firebase";
import {
  getFirestore,
  collection,
  addDoc,
  getDocs,
  serverTimestamp,
} from "firebase/firestore";
import { getStorage, ref, uploadBytes } from "firebase/storage";
import logo from "../assets/Logo 210x100mm-1.png";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";

const db = getFirestore(app);
const storage = getStorage(app);

function ProfilePage() {
  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [selfieFile, setSelfieFile] = useState(null);
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchProfiles();
  }, []);

  const fetchProfiles = async () => {
    try {
      const snapshot = await getDocs(collection(db, "profiles"));
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setProfiles(data);
    } catch (error) {
      console.error("Error fetching profiles:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Error fetching profiles",
        background: "#f8f7f3",
        color: "#5a594e",
        confirmButtonColor: "#7C7A62",
      });
    }
  };

  const handleFileChange = (e) => {
    setSelfieFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selfieFile) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please upload a selfie.",
        background: "#f8f7f3",
        color: "#5a594e",
        confirmButtonColor: "#7C7A62",
      });
      return;
    }

    setLoading(true);

    try {
      const docRef = await addDoc(collection(db, "profiles"), {
        name,
        lastName,
        email,
        phoneNumber,
        createdAt: serverTimestamp(),
      });

      const storageRef = ref(
        storage,
        `selfies/${docRef.id}/${Date.now()}_${selfieFile.name}`
      );
      await uploadBytes(storageRef, selfieFile);

      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Profile created successfully!",
        background: "#f8f7f3",
        color: "#5a594e",
        confirmButtonColor: "#7C7A62",
        timer: 3000,
      });
      setName("");
      setLastName("");
      setEmail("");
      setPhoneNumber("");
      setSelfieFile(null);
      fetchProfiles();
    } catch (error) {
      console.error("Error saving profile:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Error creating profile. Try again.",
        background: "#f8f7f3",
        color: "#5a594e",
        confirmButtonColor: "#7C7A62",
      });
    }

    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#f8f7f3] flex items-center justify-center p-4">
      <div className="w-full max-w-2xl bg-white p-8 rounded-2xl shadow-lg flex flex-col items-center border border-[#e6e5e0]">
        <div>
          <img src={logo} alt="Logo" className="h-40 object-contain mb-7" />
        </div>
        <h1 className="text-2xl font-bold text-[#5a594e] mb-1">
          Welcome to Kora Chelsea Opening Party
        </h1>
        <p className="mb-10 text-[#7C7A62]">Kindly check in.</p>

        <form onSubmit={handleSubmit} className="w-full flex flex-col gap-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label htmlFor="name" className="text-[#5a594e] font-medium">
                Name
              </label>
              <input
                type="text"
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter your first name"
                className="w-full p-3 rounded-lg border border-[#e6e5e0] focus:outline-none focus:ring-2 focus:ring-[#7C7A62] mt-1"
                required
              />
            </div>

            <div>
              <label htmlFor="lastName" className="text-[#5a594e] font-medium">
                Last Name
              </label>
              <input
                type="text"
                id="lastName"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                placeholder="Enter your last name"
                className="w-full p-3 rounded-lg border border-[#e6e5e0] focus:outline-none focus:ring-2 focus:ring-[#7C7A62] mt-1"
                required
              />
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label htmlFor="email" className="text-[#5a594e] font-medium">
                Email
              </label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                className="w-full p-3 rounded-lg border border-[#e6e5e0] focus:outline-none focus:ring-2 focus:ring-[#7C7A62] mt-1"
                required
              />
            </div>

            <div>
              <label
                htmlFor="phoneNumber"
                className="text-[#5a594e] font-medium"
              >
                Phone Number
              </label>
              <input
                type="tel"
                id="phoneNumber"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                placeholder="Enter your phone number"
                className="w-full p-3 rounded-lg border border-[#e6e5e0] focus:outline-none focus:ring-2 focus:ring-[#7C7A62] mt-1"
                required
              />
            </div>
          </div>

          <div>
            <label htmlFor="selfie" className="text-[#5a594e] font-medium">
              Selfie Photo
            </label>
            <label
              htmlFor="selfie"
              className="mt-1 flex flex-col items-center justify-center p-4 rounded-lg border-2 border-dashed border-[#e6e5e0] bg-white h-full min-h-[150px] cursor-pointer hover:border-[#7C7A62] transition-colors"
            >
              <div className="h-12 w-12 rounded-full bg-[#f1f0eb] flex items-center justify-center mb-2">
                <svg
                  className="h-6 w-6 text-[#7C7A62]"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 4v16m8-8H4"
                  />
                </svg>
              </div>
              <p className="text-sm font-medium text-[#5a594e]">
                Add Selfie Photo
              </p>
              <input
                type="file"
                id="selfie"
                onChange={handleFileChange}
                accept="image/*"
                className="hidden"
                required
              />
            </label>
            <span className="text-sm  text-[#93928a] mt-2">
              {selfieFile ? selfieFile.name : "No file chosen"}
            </span>
          </div>

          <button
            type="submit"
            className="w-full mt-4 py-3 rounded-lg bg-[#7C7A62] text-white font-semibold text-lg hover:bg-[#6b6956] transition-colors duration-200 disabled:opacity-70 disabled:cursor-not-allowed"
            disabled={loading}
          >
            {loading ? (
              <span className="flex items-center justify-center">
                <svg
                  className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                Submitting...
              </span>
            ) : (
              "Submit"
            )}
          </button>
        </form>
      </div>
    </div>
  );
}

export default ProfilePage;
